import { render } from "./PickDepto.vue?vue&type=template&id=4a53184e"
import script from "./PickDepto.vue?vue&type=script&lang=ts"
export * from "./PickDepto.vue?vue&type=script&lang=ts"
script.render = render

export default script